module.exports = __webpack_public_path__ + "img/marker.e5fb97a7.svg";